import BaseAPIService from '@/services/baseAPIService'

export default class SupportAPIService extends BaseAPIService {
  constructor(httpClient, reportingHttpClient) {
    super(httpClient, reportingHttpClient)
  }

  // Create a support ticket
  createSupportTicket(data)       { return this.httpClient.post(`/addons/support/tickets`, data) }
}
